export default class WCSelect2 {
	constructor(el, params = {}){
		this.element = el
		this.params = params

		this.init()
	}

	init(){
		const {
			placeholder,
			allowClear
		} = this.params

		$(this.element).select2({
			placeholder: placeholder || '',
			allowClear: allowClear ? true:false
		});
	}
}
